export const baseUrl: string = "/api/v1";
export const mainUrl: string = "";


